import { saveverifyQuestion } from "../ad-interface/dsu-ad.interface";

export class AddsuModel {

    private userPiasCode!: string;
    private dsuresponse!: saveverifyQuestion[];


    constructor() { }

    // Getters & Setters
    getuserPiasCode() {
        return this.userPiasCode;
    }
    setuserPiasCode(userPiasCode: string) {
        this.userPiasCode = userPiasCode;
    }


    getdsuresponse() {
        return this.dsuresponse;
    }

    setdsuresponse(data: saveverifyQuestion[]) {
        this.dsuresponse = data;
    }


    toString() {
        return JSON.stringify({
            userPiasCode:this.getuserPiasCode(),
            dsuresponse:this.getdsuresponse()
        });
    }


}
